/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CardCheckoutPaymentMethodDto } from './CardCheckoutPaymentMethodDto';
import {
    CardCheckoutPaymentMethodDtoFromJSON,
    CardCheckoutPaymentMethodDtoFromJSONTyped,
    CardCheckoutPaymentMethodDtoToJSON,
    CardCheckoutPaymentMethodDtoToJSONTyped,
} from './CardCheckoutPaymentMethodDto';
import type { BrowserInfoDto } from './BrowserInfoDto';
import {
    BrowserInfoDtoFromJSON,
    BrowserInfoDtoFromJSONTyped,
    BrowserInfoDtoToJSON,
    BrowserInfoDtoToJSONTyped,
} from './BrowserInfoDto';
import type { AuthorisePaymentTestOptions } from './AuthorisePaymentTestOptions';
import {
    AuthorisePaymentTestOptionsFromJSON,
    AuthorisePaymentTestOptionsFromJSONTyped,
    AuthorisePaymentTestOptionsToJSON,
    AuthorisePaymentTestOptionsToJSONTyped,
} from './AuthorisePaymentTestOptions';

/**
 * 
 * @export
 * @interface AuthorisePaymentRequest
 */
export interface AuthorisePaymentRequest {
    /**
     * 
     * @type {BrowserInfoDto}
     * @memberof AuthorisePaymentRequest
     */
    browserInfo?: BrowserInfoDto;
    /**
     * 
     * @type {CardCheckoutPaymentMethodDto}
     * @memberof AuthorisePaymentRequest
     */
    paymentMethod: CardCheckoutPaymentMethodDto;
    /**
     * 
     * @type {string}
     * @memberof AuthorisePaymentRequest
     */
    origin: string;
    /**
     * 
     * @type {AuthorisePaymentTestOptions}
     * @memberof AuthorisePaymentRequest
     */
    testOptions?: AuthorisePaymentTestOptions;
}

/**
 * Check if a given object implements the AuthorisePaymentRequest interface.
 */
export function instanceOfAuthorisePaymentRequest(value: object): value is AuthorisePaymentRequest {
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    return true;
}

export function AuthorisePaymentRequestFromJSON(json: any): AuthorisePaymentRequest {
    return AuthorisePaymentRequestFromJSONTyped(json, false);
}

export function AuthorisePaymentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthorisePaymentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'browserInfo': json['browserInfo'] == null ? undefined : BrowserInfoDtoFromJSON(json['browserInfo']),
        'paymentMethod': CardCheckoutPaymentMethodDtoFromJSON(json['paymentMethod']),
        'origin': json['origin'],
        'testOptions': json['testOptions'] == null ? undefined : AuthorisePaymentTestOptionsFromJSON(json['testOptions']),
    };
}

export function AuthorisePaymentRequestToJSON(json: any): AuthorisePaymentRequest {
    return AuthorisePaymentRequestToJSONTyped(json, false);
}

export function AuthorisePaymentRequestToJSONTyped(value?: AuthorisePaymentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'browserInfo': BrowserInfoDtoToJSON(value['browserInfo']),
        'paymentMethod': CardCheckoutPaymentMethodDtoToJSON(value['paymentMethod']),
        'origin': value['origin'],
        'testOptions': AuthorisePaymentTestOptionsToJSON(value['testOptions']),
    };
}

